export default "__VITE_ASSET__CtBUyg0o__ 1200w";